import { z } from 'zod';
/**
 * Bindings module query schemas — batch-2 zod migration (gh#750).
 */
/** GET /api/bindings/by-target?targetType=&targetId= */
export const byTargetQuerySchema = z.object({
    targetType: z.enum(['module', 'page', 'widget'], {
        errorMap: () => ({ message: 'targetType must be module|page|widget' }),
    }),
    targetId: z.string().min(1, 'targetId is required'),
});
//# sourceMappingURL=bindings.schema.js.map